import { useState } from "react";
import { fullDate, timeAgo } from "@/lib/timeago";

export function RelativeTime({ iso, edited, testid, className = "" }) {
  const [full, setFull] = useState(false);
  return (
    <button type="button" onClick={() => setFull((f) => !f)} data-testid={testid} data-full={full}
            aria-label={full ? "Mostrar tempo relativo" : "Mostrar data completa"}
            className={`text-[11px] text-zinc-500 hover:text-zinc-800 min-h-[24px] inline-flex items-center ${className}`}>
      <time dateTime={iso} title={fullDate(iso)}>{full ? fullDate(iso) : timeAgo(iso)}</time>{edited ? <span>&nbsp;· editado</span> : null}
    </button>
  );
}
